import { format as t, toDate as o } from "date-fns";
const n = (r) => r ? t(o(r), "MM/dd/yyyy") : "";
export {
  n as dateToString
};
